export const breakpoint = {
  sm: 480,
  md: 768,
  lg: 976,
  xlg: 1280
}

export const mediaQuery = {
  minSm: `(min-width: ${breakpoint.sm}px)`,
  maxSm: `(max-width: ${breakpoint.sm}px)`,
  minMd: `(min-width: ${breakpoint.md}px)`,
  maxMd: `(max-width: ${breakpoint.md}px)`,
  minLg: `(min-width: ${breakpoint.lg}px)`,
  maxLg: `(max-width: ${breakpoint.lg}px)`,
  minXlg: `(min-width: ${breakpoint.xlg}px)`
}

export const contentWidth = {
  xsm: '384px',
  xsmNum: 384,
  sm: '464px',
  smNum: 464,
  md: '720px',
  mdNum: 720,
  lg: '960px',
  lgNum: 960
}
